<app-table-generator
    [tableInput]="tableInput"
    [widgetRef]="widgetRef"
    (gridRef)="agGrid = $event; onGridReady()"
    [showPagination]="false"
></app-table-generator>